// export default {
//   apiUrl: process.env.NODE_ENV == "development" ? "http://localhost:5656/api" : "http://skyboardgames.com/api",
// };
// export default {
//   apiUrl: process.env.NODE_ENV == "development" ? "http://skyboardgames.com/api" : "http://skyboardgames.com/api",
// };

// ADDED NEW SERVER BUT STILL USE OLD ONE FOR DEV UNTIL HTTPS IS MADE AVAILABLE

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // apiUrl: "https://skyboardgames.com/api"
  apiUrl: process.env.REACT_APP_API_SERVER_URL,
  // apiUrl: "https://main-api-34xd.onrender.com/api",
};

